import EditPenIcon from './EditPenIcon'

export default EditPenIcon
